"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _Add = _interopRequireDefault(require("elevate-ui-icons/Add"));

var _constants = _interopRequireDefault(require("../utils/constants"));

var _Delete = _interopRequireDefault(require("../Components/Common/Delete"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RenderEditableContent = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RenderEditableContent, _Component);

  var _super = _createSuper(RenderEditableContent);

  function RenderEditableContent() {
    (0, _classCallCheck2["default"])(this, RenderEditableContent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(RenderEditableContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          child = _this$props.child,
          parent = _this$props.parent,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          internals = _this$props.internals,
          editingContentId = _this$props.internals.editingContentId,
          isActive = _this$props.isActive;
      var activeAllowChildren = editingContentId === child.id && child.attrs.allowChildren;
      var inactiveRootAllowChildren = !editingContentId && !parent && child.attrs.allowChildren;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.root, isActive && classes.active, className),
        onClick: function onClick(e) {
          return internals.showSidebar && internals.showSidebar(e, child.id);
        }
      }, children, activeAllowChildren || inactiveRootAllowChildren ? /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: classes.add,
        onClick: function onClick(e) {
          e.stopPropagation();

          if (internals.addChildToContent) {
            return internals.addChildToContent(child.id);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_Add["default"], {
        size: 18
      })) : null, !isActive || child.attrs.disableDelete ? null : /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
        className: classes["delete"],
        id: child.id,
        deleteContent: function deleteContent(id) {
          return internals.deleteContent(id);
        }
      }));
    }
  }]);
  return RenderEditableContent;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      position: "relative",
      minHeight: function minHeight(_ref) {
        var _ref$child = _ref.child,
            attrs = _ref$child.attrs,
            type = _ref$child.type;
        return type === "Row" && attrs && attrs.direction === "vertical" ? "100%" : "inherit";
      },
      // height: "100%",
      width: function width(_ref2) {
        var _ref2$child = _ref2.child,
            attrs = _ref2$child.attrs,
            type = _ref2$child.type,
            id = _ref2$child.id,
            isActive = _ref2.isActive;

        if (type === "Row") {
          return attrs && attrs.width;
        }
      },
      "&:hover": {
        boxShadow: "0px 0px 0px 2px rgba(0, 85, 172, 0.5)"
      }
    },
    active: {
      "&:after": {
        pointerEvents: "none",
        content: '""',
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
        background: "rgba(0, 85, 172, 0.1)",
        boxShadow: "0px 0px 0px 2px #0055ac",
        zIndex: _constants["default"].zIndex.elementSelected
      }
    },
    add: {
      position: "absolute",
      bottom: "-12px",
      left: "calc(50% - 12px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "24px",
      height: "24px",
      color: theme.colors.gray900,
      background: theme.colors.gray050,
      borderRadius: "50%",
      zIndex: _constants["default"].zIndex.elementAdd,
      boxShadow: theme.globalBoxShadow
    },
    "delete": {
      position: "absolute",
      right: "-24px",
      top: "-2px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "24px",
      height: "24px",
      color: theme.colors.white,
      background: "#0055ac",
      zIndex: _constants["default"].zIndex.elementDelete
    }
  };
};

var _default = (0, _withStyles["default"])(styles)(RenderEditableContent);

exports["default"] = _default;